var path = 'src/app/forms/errors.html';
var html = "<div ng-transclude></div> <div frm-error key=required is-default=true>This field is required.</div> <div frm-error key=date is-default=true>Invalid date.</div> <div frm-error key=minDate is-default=true>Date too early.</div> <div frm-error key=maxDate is-default=true>Date too late.</div> <div frm-error key=equalTo is-default=true>Values do not match.</div> <div frm-error key=email is-default=true>Invalid email.</div> <div frm-error key=integer is-default=true>Not a number.</div> <div frm-error key=number is-default=true>Not a number.</div> <div frm-error key=consent is-default=true>Patient must have consented.</div> <div frm-error ng-repeat=\"error in errors\">{{error}}</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/errors.html
 ** module id = 319
 ** module chunks = 0
 **/